export * from './platform-frontend-add/platform-frontend-add.component';
export * from './platform-frontend-edit/platform-frontend-edit.component';
export * from './platform-frontend-remove/platform-frontend-remove.component';
